import { EModal } from "@/enums"

export default function useModals() {
    const toggleModal = (id: EModal) => {
        document.getElementById(`trigger-${id}-btn`)?.click()
    }
    return {
        toggleModal
    }
}
